import { z } from "zod";

// ---------------------------------------------------------------------------
// Requests
// ---------------------------------------------------------------------------

/** The parts of a browser `PushSubscription` (its `toJSON()`) the server needs to deliver. */
export const pushSubscriptionSchema = z.object({
  endpoint: z.url({ protocol: /^https$/, error: "Must be an https URL" }).max(2048),
  keys: z.object({
    p256dh: z.string().min(1).max(256),
    auth: z.string().min(1).max(256),
  }),
});
export type PushSubscriptionInput = z.infer<typeof pushSubscriptionSchema>;

export const removePushSubscriptionSchema = z.object({ endpoint: z.string().min(1).max(2048) });
export type RemovePushSubscriptionInput = z.infer<typeof removePushSubscriptionSchema>;

// ---------------------------------------------------------------------------
// Responses
// ---------------------------------------------------------------------------

/** `publicKey` is the VAPID application server key; null when the server has push turned off. */
export const pushConfigResponseSchema = z.object({ publicKey: z.string().nullable() });
export type PushConfigResponse = z.infer<typeof pushConfigResponseSchema>;

/** How many of this device's subscriptions accepted the test notification. */
export const pushTestResponseSchema = z.object({ delivered: z.number().int().nonnegative() });
export type PushTestResponse = z.infer<typeof pushTestResponseSchema>;

// ---------------------------------------------------------------------------
// Push message (what the service worker receives)
// ---------------------------------------------------------------------------

export const pushPayloadSchema = z.object({
  title: z.string(),
  body: z.string(),
  /** App path to open when the notification is clicked. */
  url: z.string(),
  /** Replaces an earlier notification with the same tag instead of stacking. */
  tag: z.string(),
});
export type PushPayload = z.infer<typeof pushPayloadSchema>;
